import React, { Component } from 'react';
import {
    Avatar,
    Button,
    Card,
    Col,
    Collapse,
    DatePicker, Empty,
    Form, Icon,
    message,
    Modal,
    Row,
    Select,
    Skeleton,
    Spin,
    Table,
    Tag
} from "antd";
import moment from "moment";
import {
    getFuelMileageReportData,
} from "../../../appRedux/actions/Fuel";
import { connect } from "react-redux";
import './style.css';
import { fetchAssetFiltersData, searchGlobalAssetData } from "../../../appRedux/actions";
import AssetSearch from "../../../components/AssetSearch";
import LightBox from "../../../components/LightBox";
import { Link } from "react-router-dom";
import { saveAs } from 'file-saver';
import json2csv from 'json2csv';

const { Panel } = Collapse;

const { RangePicker } = DatePicker;

class AssetMileageReport extends Component {

    state = {
        selectedAsset: null
    }

    componentDidMount() {
        this.props.fetchAssetFiltersData();
    }

    handleSubmit = e => {
        e.preventDefault();
        e.stopPropagation();
        this.props.form.validateFields((err, values) => {
            if (err) {
            } else {
                // console.log(values)
                if (moment(values.periodFromTo[0]).isSameOrBefore(values.periodFromTo[1])) {

                    const payload = {
                        asset: this.state.selectedAsset,
                        location: values.location,
                        subLocation: values.subLocation,
                        assetType: values.assetType,
                        assetSubType: values.assetSubType,
                        assetModel: values.assetModel,
                        // assetCategory: values.assetCategory,
                        periodFrom: moment(values.periodFromTo[0]).startOf('day').toDate(),
                        periodTo: moment(values.periodFromTo[1]).endOf('day').toDate(),
                    };
                    // console.log(payload)
                    // console.log(payload)
                    this.props.getFuelMileageReportData(payload)
                } else {
                    message.error("Period From couldn't come earlier than Period To!");
                }
            }
        });
    };

    handleAssetSelect = (val) => {
        console.log('val=>', val)
        if (val)
            this.setState({
                selectedAsset: val
            })
    }

    downloadReport = (assetReport) => {
        if (assetReport && assetReport.length) {
            let docs = [];
            assetReport.map(data => {
                // For each record in 'data', add 'isFaultyMeter' property based on the presence of isFaultyMeter: true in mileage
                docs = docs.concat(
                    data.map(record => {
                        const hasFaultyMeter = Array.isArray(record.mileage) && record.mileage.some(m => m && m.isFaultyMeter === true);
                        return { ...record, isFaultyMeter: hasFaultyMeter };
                    })
                )

            })
            console.log(docs)
            // const uniqueMeters = [...new Set(docs.flatMap(obj => obj.meterNames))];
            // console.log(uniqueMeters)
            let fields = [
                { label: 'Date', value: (row) => row.date && moment(row.date).format('DD-MM-YYYY_HH:mm:ss') },
                { label: 'Voucher', value: 'voucherNo' },
                { label: 'Asset', value: 'asset.assetCode' },
                { label: 'Alt Name', value: 'asset.altName' },
                { label: 'Owner', value: 'asset.ownerCode' },
                { label: 'Fuel Type', value: 'typeOfFuel.name' },
                { label: 'Quantity Refilled', value: 'quantity' },
                { label: 'Quantity Consumed', value: 'quantityConsumed' },
                { label: 'Bowser', value: 'bowserAsset.assetCode' },
            ];
            const tails = [
                { label: 'Full Tank', value: 'isFullTank' },
                { label: 'Faulty Meter', value: 'isFaultyMeter' },
                { label: 'Operator', value: 'operator.name' },
                { label: 'Location', value: 'location.name' },
                { label: 'SubLocation', value: 'subLocation.name' },
                { label: 'Model', value: 'assetModel.name' },
                { label: 'Asset Type', value: 'assetType.name' },
                { label: 'Sub Type', value: 'assetSubType.name' },
            ];
            const meters = [...new Set(docs.flatMap(obj => obj.meterNames))]; //docs[0] && docs[0]['meterNames'];
            // console.log(meters)
            const meterCols = meters.map(meter => {
                return {
                    label: `${meter} Reading`,
                    value: (row) => (row.currentReading && row.currentReading.find(d => d.name === meter)) ? `${(row.currentReading.find(d => d.name === meter)).value} (${(row.currentReading.find(d => d.name === meter)).currentValue})` : ''
                }
            }).concat(
                meters.map(meter => {
                    return {
                        label: `${meter} Consumed`,
                        value: (row) => (row.consumedReading && row.consumedReading.find(d => d.name === meter)) ? (row.consumedReading.find(d => d.name === meter)).value : ''
                    }
                })).concat(
                    [].concat(...meters.map(meter => {
                        return [{
                            label: `${meter}/ Qty`, dataIndex: `${meter}/qty`, key: `${meter}/qty`, width: '80px',
                            value: (doc) => (doc.consumedMileage && doc.consumedMileage.find(d => d.name === meter)) ? (doc.consumedMileage.find(d => d.name === meter)).value : ''
                        }, {
                            label: `Qty/ ${meter}`, dataIndex: `qty/${meter}`, key: `qty/${meter}`, width: '80px',
                            value: (doc) => (doc.consumedMileagePerMeter && doc.consumedMileagePerMeter.find(d => d.name === meter)) ? (doc.consumedMileagePerMeter.find(d => d.name === meter)).value : ''
                        }]
                    })));

            fields = fields.concat(meterCols, tails)
            // Convert data to CSV format
            const csv = json2csv.parse(docs, { fields });

            // Create a Blob from the CSV data
            const blob = new Blob([csv], { type: 'text/csv;charset=utf-8' });

            // Save the CSV file using FileSaver.js
            saveAs(blob, 'consumption-report-' + new Date().getTime() + '.csv');
        }
    }

    processColumn = (reportData) => {
        let fixedCols = [
            {
                title: 'Date', dataIndex: 'date', key: 'date', width: '120px',
                render: (date) => <div>{moment(date).format('DD-MM-YYYY HH:mm A')}</div>
            },
            {
                title: 'Voucher', dataIndex: 'voucher', key: 'voucher', width: '100px',
                render: (_, record) => <Link to={`/fuel/view/${record._id}`}
                    target={'_blank'}>{record.voucherNo || '--'}</Link>
            },
            {
                title: 'Asset', dataIndex: 'asset', key: 'asset', width: '100px',
                render: (_, record) => record.asset && `${record.asset.assetCode || '-'}/ ${record.asset.altName || '-'}/ ${record.asset.ownerCode || '-'}`
            },
            {
                title: 'Alt Name', dataIndex: 'altName', key: 'altName', width: '100px',
                render: (_, record) => record.asset && record.asset.altName || '-'
            },
            {
                title: 'Photo', dataIndex: 'photo', key: 'photo', width: '50px',
                render: (_, record) => <LightBox photos={record && record.photos} />
            },
            // {
            //     title: 'Owner Code', dataIndex: 'ownerCode', key: 'ownerCode', width: '100px',
            //     render: (_, record) => record.asset && record.asset.ownerCode || '-'
            // },
            {
                title: 'Fuel',
                dataIndex: 'fuel',
                key: 'fuel',
                render: (_, record) => record.typeOfFuel && record.typeOfFuel.name
            },
            {
                title: 'Bowser',
                dataIndex: 'bowserAsset',
                key: 'bowserAsset',
                render: (_, record) => record.bowserAsset && record.bowserAsset.assetCode || '-'
            },
            {
                title: 'Quantity Refilled',
                dataIndex: 'quantity',
                key: 'quantity',
                render: (quantity) => parseFloat(quantity).toFixed(2)
            },
            {
                title: 'Quantity Consumed',
                dataIndex: 'quantityConsumed',
                key: 'quantityConsumed',
                render: (quantityConsumed) => parseFloat(quantityConsumed).toFixed(2)
            },
        ];

        const meters = reportData[reportData.length - 1] && reportData[reportData.length - 1]['meterNames'];
        // Check if meters is defined and is an array before mapping
        let meterCols = [];
        if (meters && Array.isArray(meters)) {
            meterCols = meters.map(function (meter) {
                return {
                    title: meter + ' Reading',
                    dataIndex: meter + ' Reading',
                    key: meter + ' Reading',
                    render: function (_, doc) {
                        if (doc.currentReading && doc.currentReading.find(function (d) { return d.name === meter; })) {
                            const readingRecord = doc.currentReading.find(function (d) { return d.name === meter; });
                            return `${readingRecord && readingRecord.currentValue ? parseFloat(readingRecord.currentValue).toFixed(2) : '0.00'} (${readingRecord && readingRecord.value ? parseFloat(readingRecord.value).toFixed(2) : '0.00'})`;
                        }
                        return '0.00';
                    }
                };
            });

            // Add consumed reading columns
            meters.forEach(function (meter) {
                meterCols.push({
                    title: meter + ' Consumed',
                    dataIndex: meter + ' Consumed',
                    key: meter + ' Consumed',
                    render: function (_, doc) {
                        if (doc.consumedReading && doc.consumedReading.find(function (d) { return d.name === meter; })) {
                            return parseFloat(doc.consumedReading.find(function (d) { return d.name === meter; }).value).toFixed(2);
                        }
                        return '0.00';
                    }
                });
            });

            // Add mileage columns
            meters.forEach(function (meter) {
                meterCols.push(
                    {
                        title: meter + '/ Qty',
                        dataIndex: meter + '/qty',
                        key: meter + '/qty',
                        width: '80px',
                        render: function (_, doc) {
                            if (doc.consumedMileage && doc.consumedMileage.find(function (d) { return d.name === meter; })) {
                                return parseFloat(doc.consumedMileage.find(function (d) { return d.name === meter; }).value).toFixed(2);
                            }
                            return '0.00';
                        }
                    },
                    {
                        title: 'Qty/ ' + meter,
                        dataIndex: 'qty/' + meter,
                        key: 'qty/' + meter,
                        width: '80px',
                        render: function (_, doc) {
                            if (doc.consumedMileagePerMeter && doc.consumedMileagePerMeter.find(function (d) { return d.name === meter; })) {
                                return parseFloat(doc.consumedMileagePerMeter.find(function (d) { return d.name === meter; }).value).toFixed(2);
                            }
                            return '0.00';
                        }
                    }
                );
            });
        }
        // const meterCols = meters.map(meter => {
        //     return {
        //         title: `${meter} Reading`, dataIndex: `${meter} Reading`, key: `${meter} Reading`,
        //         render: (_, doc) => doc.currentReading && parseFloat(doc.currentReading.find(d => d.name === meter).value).toFixed(2)
        //     }
        // }).concat(
        //     meters.map(meter => {
        //         return {
        //             title: `${meter} Consumed`, dataIndex: `${meter} Consumed`, key: `${meter} Consumed`,
        //             render: (_, doc) => doc.consumedReading && parseFloat(doc.consumedReading.find(d => d.name === meter).value).toFixed(2)
        //         }
        //     })).concat(
        //         [].concat(...meters.map(meter => {
        //             return [{
        //                 title: `${meter}/ Qty`, dataIndex: `${meter}/qty`, key: `${meter}/qty`, width: '80px',
        //                 render: (_, doc) => doc.consumedMileage && parseFloat(doc.consumedMileage.find(d => d.name === meter).value).toFixed(2)
        //             }, {
        //                 title: `Qty/ ${meter}`, dataIndex: `qty/${meter}`, key: `qty/${meter}`, width: '80px',
        //                 render: (_, doc) => doc.consumedMileagePerMeter && parseFloat(doc.consumedMileagePerMeter.find(d => d.name === meter).value).toFixed(2)
        //             }]
        //         })));

        const tailColumns = [
            {
                title: 'Faulty Meter', dataIndex: 'isFaultyMeter', key: 'isFaultyMeter', width: '60px', render: (_, doc) => {
                    const faultyRecod = (doc.mileage || []).some(m => m.isFaultyMeter)
                    return <div>{faultyRecod ? <Icon type="check-circle" theme="twoTone" twoToneColor="#52c41a" /> :
                        <Icon type="close-circle" theme="twoTone" twoToneColor="#eb2f96" />}</div>
                }
            },
            {
                title: 'Full Tank', dataIndex: 'isFullTank', key: 'isFullTank', width: '60px', render: (isFullTank) => {
                    return <div>{isFullTank ? <Icon type="check-circle" theme="twoTone" twoToneColor="#52c41a" /> :
                        <Icon type="close-circle" theme="twoTone" twoToneColor="#eb2f96" />}</div>
                }
            },
            {
                title: 'Operator', dataIndex: 'operator', key: 'operator', render: (operator) => {
                    return operator && operator.name
                }
            },
            {
                title: 'Location',
                dataIndex: 'location',
                key: 'location',
                render: (location) => {
                    return location && location.name
                }
            },
            {
                title: 'Sub Location', dataIndex: 'subLocation', key: 'subLocation', render: (subLocation) => {
                    return subLocation && subLocation.name
                }
            },
            {
                title: 'Model', dataIndex: 'assetModel', key: 'assetModel', width: '120px', render: (assetModel) => {
                    return assetModel && assetModel.name
                }
            },
            {
                title: 'Asset Type', dataIndex: 'assetType', key: 'assetType', render: (assetType) => {
                    return assetType && assetType.name
                }
            },
            {
                title: 'Sub Type', dataIndex: 'assetSubType', key: 'assetSubType', render: (assetSubType) => {
                    return assetSubType && assetSubType.name
                }
            },
        ];
        fixedCols = fixedCols.concat(meterCols, tailColumns)
        // console.log(fixedCols)
        return fixedCols;

    }


    render() {

        const { getFieldDecorator, setFieldsValue } = this.props.form;
        const { loading, mileage_report_data, assetFilters } = this.props;

        const { assetTypes, assetSubTypes, assetModels, assetCategories } = assetFilters || {};

        // console.log(mileage_report_data)

        const totalRefilled = new Map();
        const totalQuantityConsumed = new Map();
        const totalMeterConsumed = new Map();

        const assetReportData = (mileage_report_data || []).map(doc => {
            let reportData = [];
            let asset = null;
            Object.keys(doc).map(assetId => {
                reportData = doc[assetId];
                asset = assetId;
            });

            let refilled = 0;
            let quantityConsumed = 0;
            let consumedReadingMap = {};
            reportData.forEach(data => {
                refilled += data.quantity || 0;
                quantityConsumed += data.quantityConsumed || 0;
                data.consumedReading && (data.consumedReading || []).forEach(meter => {
                    if (meter && meter.name) {
                        consumedReadingMap[meter.name] = (consumedReadingMap[meter.name] || 0) + (meter.value || 0);
                    }
                });
            });

            // Convert the map back to array format
            const consumedReading = Object.keys(consumedReadingMap).map(name => ({
                name: name,
                value: consumedReadingMap[name]
            }));
            // consumedMileage = {};
            totalRefilled.set(asset, refilled);
            totalQuantityConsumed.set(asset, quantityConsumed);
            totalMeterConsumed.set(asset, consumedReading);

            return reportData;
        })

        return (

            <div>
                <Spin spinning={loading}>
                    <Card
                        className={`gx-card-metrics`}
                        title={`Fuel Consumption Rate Report`}
                    >
                        <Form
                            onSubmit={this.handleSubmit}
                            className="ant-advanced-search-form"
                            layout="inline"
                            labelAlign="left"
                        >
                            <Row gutter={8}>
                                <Col xs={24} sm={12} md={8} lg={5} xl={5}>
                                    <Form.Item key={'location'} label={'Location'} style={{ width: '100%' }}>
                                        {getFieldDecorator(`location`, {
                                            rules: [{ required: true, message: `Location is required!` }],
                                        })(<Select
                                            showSearch
                                            showArrow
                                            filterOption={(input, option) =>
                                                (option.props.children + "").toLowerCase().indexOf((input + "").toLowerCase()) >= 0
                                            }
                                            placeholder={`Select Location`}
                                        >
                                            <Select.Option key={'AllLocation'}
                                                value={'all'}>All</Select.Option>
                                            {(this.props.authUser && this.props.authUser.locations || []).map(item =>
                                                <Select.Option key={item._id}
                                                    value={item._id}>{item.name}</Select.Option>)}

                                        </Select>)
                                        }
                                    </Form.Item>
                                </Col>
                                <Col xs={24} sm={12} md={8} lg={5} xl={5}>
                                    <Form.Item key={'subLocation'} label={'Sub Location'} style={{ width: '100%' }}>
                                        {getFieldDecorator(`subLocation`, {
                                            rules: [{ required: true, message: `Sub Location is required!` }],
                                        })(<Select
                                            showSearch
                                            showArrow
                                            filterOption={(input, option) =>
                                                (option.props.children + "").toLowerCase().indexOf((input + "").toLowerCase()) >= 0
                                            }
                                            placeholder={`Select Sub Location`}
                                        >
                                            <Select.Option key={'AllSubLocation'}
                                                value={'all'}>All</Select.Option>
                                            {(this.props.authUser && this.props.authUser.clients || []).map(item =>
                                                <Select.Option key={item._id}
                                                    value={item._id}>{item.name}</Select.Option>)}

                                        </Select>)
                                        }
                                    </Form.Item>
                                </Col>

                                <Col xs={24} sm={12} md={8} lg={5} xl={5}>
                                    <Form.Item
                                        key={"periodFromTo"}
                                        label={"Select Period"}
                                        style={{ width: "100%" }}
                                    >
                                        {getFieldDecorator(`periodFromTo`, {
                                            rules: [
                                                { required: true, message: `Period From To is required!` }
                                            ],
                                            initialValue: null
                                        })(<RangePicker style={{ width: "100%" }} />)}
                                    </Form.Item>
                                </Col>

                                <Col xs={24} sm={12} md={8} lg={5} xl={5}>
                                    <Form.Item
                                        key={"assetType"}
                                        label={"Asset Type"}
                                        style={{ width: "100%" }}
                                    >
                                        {getFieldDecorator(`assetType`, {
                                            onChange: () => {
                                                // Reset subType and model when type changes
                                                this.props.form.setFieldsValue({
                                                    assetSubType: 'all',
                                                    assetModel: 'all'
                                                })
                                            }
                                        })(
                                            <Select
                                                showSearch
                                                showArrow
                                                filterOption={(input, option) =>
                                                    (option.props.children + "").toLowerCase().indexOf((input + "").toLowerCase()) >= 0
                                                }
                                                placeholder={`Select Asset Type`}
                                            >
                                                <Select.Option key={'AllType'}
                                                    value={'all'}>All</Select.Option>
                                                {(assetTypes || []).map(item =>
                                                    <Select.Option key={item._id}
                                                        value={item._id}>{item.name}</Select.Option>)}

                                            </Select>
                                        )}
                                    </Form.Item>
                                </Col>

                                <Col xs={24} sm={12} md={8} lg={5} xl={5}>
                                    <Form.Item
                                        key={"assetSubType"}
                                        label={"Asset Sub Type"}
                                        style={{ width: "100%" }}
                                    >
                                        {getFieldDecorator(`assetSubType`, {
                                            onChange: () => {
                                                // Reset model when subType changes
                                                this.props.form.setFieldsValue({
                                                    assetModel: 'all'
                                                })
                                            }
                                        })(
                                            <Select
                                                showSearch
                                                showArrow
                                                filterOption={(input, option) =>
                                                    (option.props.children + "").toLowerCase().indexOf((input + "").toLowerCase()) >= 0
                                                }
                                                placeholder={`Select Asset Sub Type`}
                                            >
                                                <Select.Option key={'AllSubType'}
                                                    value={'all'}>All</Select.Option>
                                                {(assetSubTypes || [])
                                                    .filter(item => {
                                                        const selectedAssetType = this.props.form.getFieldValue('assetType')
                                                        return selectedAssetType === 'all' || item.assetType === selectedAssetType
                                                    })
                                                    .map(item =>
                                                        <Select.Option key={item._id}
                                                            value={item._id}>{item.name}</Select.Option>)}

                                            </Select>
                                        )}
                                    </Form.Item>
                                </Col>
                                <Col xs={24} sm={12} md={8} lg={5} xl={5}>
                                    <Form.Item
                                        key={"assetModel"}
                                        label={"Asset Model"}
                                        style={{ width: "100%" }}
                                    >
                                        {getFieldDecorator(`assetModel`)(
                                            <Select
                                                showSearch
                                                showArrow
                                                filterOption={(input, option) =>
                                                    (option.props.children + "").toLowerCase().indexOf((input + "").toLowerCase()) >= 0
                                                }
                                                placeholder={`Select Asset Model`}
                                            >
                                                <Select.Option key={'AllModel'}
                                                    value={'all'}>All</Select.Option>
                                                {(assetModels || [])
                                                    .filter(item => {
                                                        const selectedAssetType = this.props.form.getFieldValue('assetType')
                                                        const selectedAssetSubType = this.props.form.getFieldValue('assetSubType')

                                                        // If both type and subtype are 'all', show all models
                                                        if (selectedAssetType === 'all' && selectedAssetSubType === 'all') return true

                                                        // If subtype is selected (regardless of asset type), filter by subtype
                                                        if (selectedAssetSubType !== 'all') {
                                                            return item.assetSubType === selectedAssetSubType
                                                        }

                                                        // If only asset type is selected (subtype is 'all'), show models for all subtypes of selected type
                                                        if (selectedAssetType !== 'all') {
                                                            const validSubTypes = assetSubTypes
                                                                .filter(st => st.assetType === selectedAssetType)
                                                                .map(st => st._id)
                                                            return validSubTypes.includes(item.assetSubType)
                                                        }

                                                        return true
                                                    })
                                                    .map(item =>
                                                        <Select.Option key={item._id}
                                                            value={item._id}>{item.name}</Select.Option>)}

                                            </Select>
                                        )}
                                    </Form.Item>
                                </Col>


                                <Col xs={24} sm={12} md={8} lg={5} xl={5}>
                                    <Form.Item key={'asset'} label={'Search Asset'} style={{ width: '100%' }}>
                                        {getFieldDecorator(`asset`, {
                                            rules: [{ required: false, message: `Asset is required!` }],
                                        })(<AssetSearch
                                            styleName="gx-lt-icon-search-bar-lg"
                                            placeholder="Or search any Asset..."
                                            onChange={this.props.searchGlobalAssetData}
                                            assetData={
                                                this.props.assetData && this.props.assetData.filter((ast) => ast.assetModel)
                                            } // only assets with assetModel
                                            onSelect={this.handleAssetSelect}
                                            authUser={this.props.authUser}
                                            loading={this.props.assetSearchLoading}
                                        // multiple={f}
                                        />)}
                                    </Form.Item>
                                </Col>
                                <Col xs={24} sm={12} md={8} lg={5} xl={5}>
                                    <Form.Item style={{ marginTop: '25px' }}>
                                        <span style={{ display: 'flex', flexDirection: 'row' }}>
                                            <Button type="primary" htmlType="submit" loading={loading}>
                                                Generate Report
                                            </Button>
                                            <Button disabled={!assetReportData || !assetReportData.length}
                                                type="default" htmlType="button" loading={loading} icon={'download'}
                                                onClick={() => this.downloadReport(assetReportData)}>
                                                Download
                                            </Button>
                                        </span>
                                    </Form.Item>
                                </Col>
                            </Row>
                        </Form>

                        {assetReportData && assetReportData.length ? assetReportData.map((report, inx) => {
                            // const primary = report && report[report.length - 1];
                            if (!report || report.length === 0 || !report[0].asset) {
                                return null;
                            }
                            const primary = {
                                asset: report[0].asset,
                                totalQuantityConsumed: totalQuantityConsumed.get(report[0].asset._id) || 0,
                                totalMeterConsumed: totalMeterConsumed.get(report[0].asset._id) || [],
                                totalRefilled: totalRefilled.get(report[0].asset._id) || 0,
                            }


                            return report.length > 0 ? (<Collapse bordered={false}>
                                <Panel header={
                                    <Row className='mileage-row'>
                                        <Col xs={24} sm={12} md={4} lg={4}>
                                            <div className='job-card-details'>
                                                <div
                                                    className='content-row-style'>{primary && primary.asset && `${primary.asset.assetCode || '-'} / ${primary.asset.altName || '-'} / ${primary.asset.ownerCode || '-'}`}</div>
                                            </div>
                                        </Col>

                                        <Col xs={24} sm={12} md={4} lg={4}>
                                            <div className='job-card-details'>
                                                <div className='content-row-style'>Total Refilled
                                                    : {primary && parseFloat(primary.totalRefilled || 0).toFixed(2)}</div>
                                            </div>
                                        </Col>
                                        <Col xs={24} sm={12} md={4} lg={4}>
                                            <div className='job-card-details'>
                                                <div className='content-row-style'>Total Qty Consumed
                                                    : {primary && parseFloat(primary.totalQuantityConsumed || 0).toFixed(2)}
                                                </div>
                                            </div>
                                        </Col>
                                        <Col xs={24} sm={12} md={4} lg={4}>
                                            <div className='job-card-details'>
                                                <div className='content-row-style'>Total Meter Consumed
                                                    : {primary && primary.totalMeterConsumed && primary.totalMeterConsumed.length
                                                        ? primary.totalMeterConsumed.map(consume => `${parseFloat(consume.value).toFixed(2)} ${consume.name}`).join(', ')
                                                        : 'N/A'}
                                                </div>
                                            </div>
                                        </Col>
                                        <Col xs={24} sm={12} md={4} lg={4}>
                                            <div className='job-card-details'>
                                                <div className='content-row-style'>Average Consumption Rate
                                                    {(primary && primary.totalMeterConsumed && primary.totalMeterConsumed.length) ? (
                                                        primary.totalMeterConsumed.map(consume => {
                                                            const qtyPerUnit = primary.totalQuantityConsumed ? consume.value / primary.totalQuantityConsumed : 0
                                                            const unitPerQty = consume.value ? primary.totalQuantityConsumed / consume.value : 0
                                                            return `${Math.round(qtyPerUnit * 100) / 100} ${consume.name}/Qty (${Math.round(unitPerQty * 100) / 100} Qty/${consume.name})`
                                                        }).join(', ')
                                                    ) : 'N/A'}</div>
                                            </div>
                                        </Col>

                                    </Row>
                                } key={inx}>
                                    <Table dataSource={report} columns={this.processColumn(report)} pagination={false}
                                        rowKey={'_id'}
                                        scroll={{ x: true }} bordered />
                                </Panel>
                            </Collapse>) : null
                        }
                        ) : loading ? <Skeleton active /> : <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />}
                    </Card>
                </Spin>
            </div>
        );
    }
}

const mapStateToProps = ({ auth, fuel, commonData }) => {
    return {
        authUser: auth.authUser,
        loading: commonData.loading,
        mileage_report_data: fuel.mileage_report_data,
        assetFilters: commonData.assetFilters,
        assetData: commonData.assetSearchData,
        assetSearchLoading: commonData.assetSearchLoading,
    };
};

function mapDispatchToProps(dispatch) {
    return {
        getFuelMileageReportData,
        fetchAssetFiltersData,
        searchGlobalAssetData
    };
}

const AssetFuelMileageReport = Form.create({ name: 'asset-mileage-report' })(AssetMileageReport);
export default connect(mapStateToProps, mapDispatchToProps())(AssetFuelMileageReport);
